export var DEFAULT_CONFIG = Object.freeze({
  baseURL: '/api',
  timeout: 10000,
  responseType: 'json'
});
export var UNKNOWN_ERROR = 0;
export var NETWORK_ERROR = 'NETWORK_ERROR';
export var TIMEOUT_ERROR = 'TIMEOUT_ERROR';
export var CONNECTION_ERROR = 'CONNECTION_ERROR';